export function profileFactory($resource, MyConstant) {
	"ngInject"

	return $resource('', {}, {
		save: {
			url: `${MyConstant.ApiUrl}Profile/SaveProfile`,
			method: 'POST'
		},
		get: {
			url: `${MyConstant.ApiUrl}Profile/GetProfile`
		}
	})
}


// WEBPACK FOOTER //
// ./src/factories/profile/profile.ts